import React from 'react'
import { FIREBASE_EVENTS, SCREEN_TABLET, URLS } from 'app-constants'
import { STATICS } from 'statics'
import { useFirebaseEvent } from 'hooks'
import { BaseCard } from '../base-card'

export function SpeedTestCard() {
  const { sendEvent } = useFirebaseEvent()

  function handleClick() {
    sendEvent(FIREBASE_EVENTS.CLICK_ON_INTERNET_SPEED_TEST)

    if (window.innerWidth < SCREEN_TABLET) window.location.href = URLS.SPEED_TEST

    return window.open(URLS.SPEED_TEST, '_blank').focus()
  }

  return <BaseCard onClick={handleClick} text='Teste de velocidade' icon={<STATICS.SPEED_TEST />} />
}
